import React, { AnchorHTMLAttributes, DetailedHTMLProps } from "react";
import { useConfirmationModalContext } from "./modalConfirmationContext";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

type Props = {
  onClick: (event: any) => void;
  hidden?: boolean;
};

const DeleteButton = (props: Props) => {
  const modalContext = useConfirmationModalContext();

  const handleOnClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    const result = await modalContext.showConfirmation(
      "Confirmación",
      <div>
        <p>¿Estás seguro que deseas eliminar el registro?</p>
      </div>
    );
    result && props.onClick && props.onClick(event);
  };

  return (
    <Button
      variant="danger"
      size="sm"
      active
      onClick={handleOnClick}
      hidden={props.hidden != undefined ? props.hidden : false}
    >
      <a>
        <FontAwesomeIcon icon={faTrash} className="white" />
      </a>
    </Button>
  );
};

export default DeleteButton;
